module.exports = __webpack_public_path__ + "img/cat-03-in.be95a972.svg";